import { createFileRoute, Link } from "@tanstack/react-router";
import { BookOpen, ArrowRight } from "lucide-react";
import portalImg from "@/assets/artigo-portal-mei.webp";
import oqueImg from "@/assets/artigo-o-que-e-mei.webp";
import formImg from "@/assets/artigo-formalizacao.webp";
import dasImg from "@/assets/artigo-das-boleto.webp";
import funcImg from "@/assets/artigo-mei-funcionario.webp";
import meiMeImg from "@/assets/artigo-mei-x-me.webp";
import parcImg from "@/assets/artigo-parcelamento-mei.webp";
import limiteImg from "@/assets/artigo-limite-faturamento.webp";
import cancelImg from "@/assets/artigo-cancelar-mei.webp";
import atvImg from "@/assets/artigo-atividades-mei.webp";
import alvaraImg from "@/assets/artigo-alvara-mei.webp";
import alterarImg from "@/assets/artigo-alterar-dados-mei.webp";
import nfImg from "@/assets/artigo-nota-fiscal-mei.webp";
import nomeSujoImg from "@/assets/artigo-mei-nome-sujo.webp";
import reformaImg from "@/assets/artigo-reforma-tributaria-mei.webp";
import inssImg from "@/assets/artigo-mei-inss.webp";
import contaPjImg from "@/assets/artigo-conta-pj-mei.webp";
import irpfImg from "@/assets/artigo-mei-irpf.webp";
import beneficiosImg from "@/assets/artigo-beneficios-mei.webp";
import certDigImg from "@/assets/artigo-certificado-digital-mei.webp";
import migrarMeImg from "@/assets/artigo-migrar-mei-me.webp";
import ecommerceImg from "@/assets/artigo-mei-ecommerce.webp";
import simplesNacImg from "@/assets/artigo-mei-simples-nacional.webp";
import femininoImg from "@/assets/artigo-mei-feminino.webp";
import inadimplenteImg from "@/assets/artigo-mei-inadimplente.webp";
import servicoPjImg from "@/assets/artigo-mei-prestar-servico-pj.webp";
import cltImg from "@/assets/artigo-mei-clt.webp";
import socioImg from "@/assets/artigo-mei-socio.webp";
import cnpjRapidoImg from "@/assets/artigo-cartao-cnpj-rapido.webp";
import cnpjVantagensImg from "@/assets/artigo-vantagens-cartao-cnpj.webp";
import cnpjPassoImg from "@/assets/artigo-passo-cartao-cnpj.webp";
import cnpjDocImg from "@/assets/artigo-documentacao-cnpj.webp";
import cnpjLegalImg from "@/assets/artigo-importancia-cnpj.webp";
import nfeEletronicaImg from "@/assets/artigo-mei-nfe-eletronica.webp";
import inss2026Img from "@/assets/artigo-inss-mei-2026.webp";
import obrigMensaisImg from "@/assets/artigo-obrigacoes-mensais-mei.webp";
import emprestimoMeiImg from "@/assets/artigo-simulador-emprestimo-mei.jpg";
import maquininhaImg from "@/assets/artigo-simulador-maquininha.jpg";
import meiVsCltImg from "@/assets/artigo-mei-vs-clt-2026.jpg";
import iaCnaeMeiImg from "@/assets/artigo-ia-cnae-mei-2026.jpg";
import dasnSimeiImg from "@/assets/artigo-dasn-simei-declaracao-anual.jpg";
import entregadorMlImg from "@/assets/artigo-entregador-mercado-livre-mei.webp";
import mei2026CgsnImg from "@/assets/artigo-mei-2026-cgsn-183.jpg";
import desenquadramentoImg from "@/assets/artigo-desenquadramento-mei.png";
import ferramentasKitImg from "@/assets/artigo-ferramentas-mei-kit.png";
import dasMei2026Img from "@/assets/artigo-das-mei-2026.jpg";
import irpfMei2026Img from "@/assets/artigo-mei-irpf.webp";
import gestaoFinanceiraImg from "@/assets/artigo-conta-pj-mei.webp";
import creditoEmprestimoImg from "@/assets/artigo-simulador-emprestimo-mei.jpg";
import emprestimoCaixaImg from "@/assets/artigo-emprestimo-caixa-mei.jpg";

import marketingDigitalImg from "@/assets/artigo-mei-ecommerce.webp";
import nanoempreendedorImg from "@/assets/artigo-reforma-tributaria-mei.webp";

export const Route = createFileRoute("/artigos/")({
  head: () => ({
    meta: [
      { title: "Artigos MEI 2026: Guias Práticos de DAS, Nota Fiscal e INSS" },
      {
        name: "description",
        content:
          "+35 guias grátis sobre MEI 2026: como pagar DAS, emitir nota fiscal, INSS, limite de faturamento e formalização. Conteúdo simples, claro e direto ao ponto.",
      },
      { property: "og:title", content: "Artigos sobre MEI 2026 | MEI Toolbox" },
      {
        property: "og:description",
        content:
          "Conteúdo prático e atualizado sobre MEI: DAS, nota fiscal, INSS, formalização e obrigações mensais.",
      },
      { property: "og:url", content: "https://meitoolbox.com.br/artigos" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Artigos sobre MEI 2026 | MEI Toolbox" },
      {
        name: "twitter:description",
        content: "Guias práticos sobre DAS, nota fiscal, INSS e obrigações mensais do MEI.",
      },
    ],
    links: [
      { rel: "canonical", href: "https://meitoolbox.com.br/artigos" },
      // Preload das primeiras thumbnails (above the fold) — melhora LCP
      { rel: "preload", as: "image", href: portalImg, fetchpriority: "high" },
      { rel: "preload", as: "image", href: oqueImg },
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Início",
              item: "https://meitoolbox.com.br/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "Artigos",
              item: "https://meitoolbox.com.br/artigos",
            },
          ],
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Blog",
          name: "Artigos MEI Toolbox",
          url: "https://meitoolbox.com.br/artigos",
          inLanguage: "pt-BR",
          publisher: { "@id": "https://meitoolbox.com.br/#organization" },
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: [
            {
              "@type": "Question",
              name: "Quais são as obrigações mensais do MEI em 2026?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "Todo mês o MEI precisa pagar o DAS (boleto único com INSS, ISS e ICMS), emitir nota fiscal nas vendas para empresas (PJ), controlar o faturamento para não passar do teto anual de R$ 81.000 e guardar os comprovantes por pelo menos 5 anos.",
              },
            },
            {
              "@type": "Question",
              name: "Qual o valor do DAS MEI em 2026?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "Em 2026 o DAS-MEI tem como base R$ 81,05 de INSS (5% do salário mínimo), mais R$ 1 de ICMS para comércio/indústria e R$ 5 de ISS para serviços. O valor final depende da sua atividade.",
              },
            },
            {
              "@type": "Question",
              name: "Como funciona a nota fiscal eletrônica para MEI?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "Desde 2026 o MEI usa o padrão nacional da NFS-e (serviços) e o novo CRT 4. A emissão é obrigatória nas vendas para empresas e opcional para pessoa física. Pode ser feita pelo portal nacional ou pela prefeitura.",
              },
            },
            {
              "@type": "Question",
              name: "Qual o limite de faturamento do MEI?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "O teto atual do MEI é R$ 81.000 por ano. Ultrapassar até 20% (R$ 97.200) leva ao desenquadramento no ano seguinte. Acima disso, o desenquadramento é retroativo.",
              },
            },
            {
              "@type": "Question",
              name: "MEI precisa declarar Imposto de Renda?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "São duas obrigações diferentes. A DASN-SIMEI é anual e obrigatória para todo MEI. Já a declaração de IRPF (pessoa física) só é exigida se o titular se enquadrar nas regras gerais da Receita Federal.",
              },
            },
          ],
        }),
      },
    ],
  }),
  component: ArtigosPage,
});

export const ARTIGOS_LIST = [
  // ── DESTAQUES DA PÁGINA INICIAL (topo do carrossel) ────────────────────────
  {
    slug: "irpf-mei-2026",
    titulo: "IRPF do MEI 2026: Como Declarar o Lucro no Imposto de Renda Sem Cair na Malha Fina",
    resumo:
      "Calcule a parcela isenta (8%, 16% ou 32% da receita bruta), preencha as fichas certas do IRPF e evite a malha fina da Receita Federal.",
    categoria: "Imposto de Renda",
    tempo: "16 min de leitura",
    imagem: irpfMei2026Img,
    tag: "IRPF do MEI",
  },
  {
    slug: "gestao-financeira-mei",
    titulo: "Gestão Financeira para MEI 2026: Fluxo de Caixa, Controle e Ferramentas Gratuitas",
    resumo:
      "Separe contas pessoais e empresariais, monte um fluxo de caixa, defina o pró-labore e controle o limite de faturamento com ferramentas gratuitas.",
    categoria: "Finanças",
    tempo: "17 min de leitura",
    imagem: gestaoFinanceiraImg,
    tag: "Controle financeiro do MEI",
  },
  {
    slug: "credito-emprestimo-mei-2026",
    titulo: "Empréstimo para MEI 2026: Pronampe, BNDES e Como Conseguir Crédito com Taxas Baixas",
    resumo:
      "Guia completo de crédito para MEI: Pronampe (SELIC + 6%), BNDES Microcrédito, Cartão BNDES, fintechs e como aumentar as chances de aprovação.",
    categoria: "Crédito e Finanças",
    tempo: "18 min de leitura",
    imagem: creditoEmprestimoImg,
    tag: "Crédito e Pronampe para MEI",
  },
  {
    slug: "emprestimo-caixa-mei",
    titulo: "Empréstimo Caixa para MEI 2026: Como Pedir Crédito de Até R$ 21 Mil Passo a Passo",
    resumo:
      "Linhas da Caixa para MEI, requisitos, documentos, passo a passo do pedido e o que fazer para aumentar a chance de aprovação.",
    categoria: "Crédito e Finanças",
    tempo: "11 min de leitura",
    imagem: emprestimoCaixaImg,
    tag: "Crédito na Caixa para MEI",
  },

  // ── ARTIGOS EXISTENTES ─────────────────────────────────────────────────────
  {
    slug: "como-calcular-das-mei-2026",
    titulo: "Como Calcular o DAS MEI 2026: Guia Completo com Tabela Atualizada",
    resumo:
      "Tabela completa 2026, fórmula de cálculo, diferença entre comércio/serviço/caminhoneiro, exemplos práticos e passo a passo no PGMEI. Com FAQ de 15 perguntas.",
    categoria: "Tributos",
    tempo: "14 min de leitura",
    imagem: dasMei2026Img,
    tag: "Guia MEI 2026",
  },
  {
    slug: "ferramentas-mei-kit-gratuito",
    titulo: "Ferramentas para MEI 2026: o kit gratuito definitivo",
    resumo:
      "Monte um kit de recursos digitais gratuitos para a rotina do MEI em 2026: DAS, NFS-e, limite de faturamento e controle de caixa sem custo.",
    categoria: "Ferramentas",
    tempo: "9 min de leitura",
    imagem: ferramentasKitImg,
    tag: "Kit de Ferramentas MEI",
  },
  {
    slug: "desenquadramento-mei-como-agir",
    titulo: "Desenquadramento do MEI: causas, efeitos e como agir",
    resumo:
      "Faturou acima do limite ou violou alguma regra? Veja as causas, os prazos e como regularizar seu CNPJ ou migrar para ME.",
    categoria: "Migração",
    tempo: "10 min de leitura",
    imagem: desenquadramentoImg,
    tag: "Desenquadramento do SIMEI",
  },
  {
    slug: "mei-2026-cgsn-183",
    titulo:
      "MEI 2026: a mudança silenciosa da Resolução CGSN 183/2025 que pode desenquadrar seu CNPJ",
    resumo:
      "Como a CGSN 183/2025 muda o cálculo do faturamento para quem é MEI + CLT, novos valores do DAS em 2026 e o que fazer se perdeu a DASN-SIMEI.",
    categoria: "MEI 2026",
    tempo: "10 min de leitura",
    imagem: mei2026CgsnImg,
    tag: "Mudanças do MEI em 2026",
  },
  {
    slug: "portal-mei-guia-completo",
    titulo: "Portal MEI: como acessar, usar e não se perder nos serviços do governo",
    resumo:
      "Guia completo dos portais oficiais: Portal do Empreendedor, PGMEI, Gov.br, app MEI, DASN-SIMEI e mais.",
    categoria: "Guia Completo",
    tempo: "12 min de leitura",
    imagem: portalImg,
    tag: "Portais oficiais",
  },
  {
    slug: "o-que-e-mei",
    titulo: "O que é MEI? Entenda tudo sobre o Microempreendedor Individual",
    resumo: "Benefícios, obrigações, impostos, INSS, nota fiscal e perfis que se encaixam no MEI.",
    categoria: "Fundamentos",
    tempo: "10 min de leitura",
    imagem: oqueImg,
    tag: "Conceitos básicos",
  },
  {
    slug: "como-formalizar-mei",
    titulo: "Como formalizar seu MEI: passo a passo completo",
    resumo:
      "Critérios, atividades permitidas, abertura no Portal do Empreendedor e o que fazer logo depois.",
    categoria: "Formalização",
    tempo: "9 min de leitura",
    imagem: formImg,
    tag: "Abertura do CNPJ",
  },
  {
    slug: "das-boleto-mei",
    titulo: "DAS do MEI: como gerar, pagar e parcelar o boleto mensal",
    resumo:
      "PGMEI, app MEI, PIX, débito automático, parcelamento e tudo sobre vencimento e atrasos.",
    categoria: "Tributos",
    tempo: "11 min de leitura",
    imagem: dasImg,
    tag: "Boleto mensal",
  },
  {
    slug: "mei-pode-ter-funcionario",
    titulo: "MEI pode ter funcionário? Tudo sobre contratação de empregado pelo MEI",
    resumo:
      "Quantos empregados o MEI pode ter, salário, custos, eSocial, demissão e contratação de outro MEI.",
    categoria: "Trabalhista",
    tempo: "13 min de leitura",
    imagem: funcImg,
    tag: "Contratação de empregado",
  },
  {
    slug: "mei-x-me-diferencas",
    titulo: "MEI x ME: qual é o melhor para o seu negócio? Entenda as diferenças",
    resumo:
      "Limites, impostos, sócios, funcionários e quando faz sentido migrar do MEI para a Microempresa.",
    categoria: "MEI x ME",
    tempo: "13 min de leitura",
    imagem: meiMeImg,
    tag: "Comparativo MEI vs ME",
  },
  {
    slug: "parcelamento-dividas-mei",
    titulo: "Parcelamento de dívidas do MEI: como regularizar a situação",
    resumo:
      "Como parcelar DAS em atraso, programas especiais e como recuperar todos os direitos do MEI.",
    categoria: "Regularização",
    tempo: "13 min de leitura",
    imagem: parcImg,
    tag: "DAS em atraso",
  },
  {
    slug: "limite-faturamento-mei",
    titulo: "Limite de faturamento MEI: o que fazer ao chegar no teto",
    resumo:
      "R$ 81.000 por ano: o que acontece se ultrapassar, como calcular e como planejar a migração.",
    categoria: "Faturamento",
    tempo: "13 min de leitura",
    imagem: limiteImg,
    tag: "Teto do MEI",
  },
  {
    slug: "como-cancelar-mei-dar-baixa",
    titulo: "Como cancelar o MEI: passo a passo para dar baixa no CNPJ",
    resumo:
      "Quando cancelar, o que regularizar antes, passo a passo no Portal do Empreendedor e o que muda no INSS.",
    categoria: "Cancelamento",
    tempo: "13 min de leitura",
    imagem: cancelImg,
    tag: "Baixa do CNPJ",
  },
  {
    slug: "atividades-permitidas-mei",
    titulo: "Atividades permitidas para MEI: lista e como escolher a sua",
    resumo:
      "Mais de 600 atividades autorizadas, CNAEs, profissões não permitidas e como verificar a sua.",
    categoria: "Atividades",
    tempo: "13 min de leitura",
    imagem: atvImg,
    tag: "Lista de CNAEs",
  },
  {
    slug: "alvara-funcionamento-mei",
    titulo: "Alvará de funcionamento para MEI: quando é obrigatório e como obter",
    resumo:
      "Quando o MEI precisa de alvará, como solicitar pela prefeitura e quais outras licenças podem ser exigidas.",
    categoria: "Licenças",
    tempo: "10 min de leitura",
    imagem: alvaraImg,
    tag: "Alvará e licenças",
  },
  {
    slug: "alterar-dados-mei",
    titulo: "Como alterar dados do MEI: nome fantasia, endereço e atividade",
    resumo:
      "Passo a passo gratuito no Portal do Empreendedor para atualizar nome, endereço e CNAEs.",
    categoria: "Cadastro",
    tempo: "9 min de leitura",
    imagem: alterarImg,
    tag: "Atualização cadastral",
  },
  {
    slug: "nota-fiscal-mei",
    titulo: "Como emitir nota fiscal pelo MEI: guia completo",
    resumo:
      "Quando emitir, tipos de nota (NFS-e, NF-e, NFC-e) e como se cadastrar pela prefeitura ou SEFAZ.",
    categoria: "Nota Fiscal",
    tempo: "10 min de leitura",
    imagem: nfImg,
    tag: "Emissão de NF",
  },
  {
    slug: "mei-nome-sujo",
    titulo: "MEI com nome sujo: é possível abrir MEI com restrição no CPF?",
    resumo:
      "Sim, dá para abrir MEI mesmo negativado. Veja as limitações práticas e como se preparar.",
    categoria: "Crédito",
    tempo: "9 min de leitura",
    imagem: nomeSujoImg,
    tag: "Restrição no CPF",
  },
  {
    slug: "reforma-tributaria-mei",
    titulo: "MEI e a Reforma Tributária: o que muda para o microempreendedor",
    resumo: "CBS, IBS, Imposto Seletivo e a transição até 2033 — entenda o que afeta o seu MEI.",
    categoria: "Reforma Tributária",
    tempo: "10 min de leitura",
    imagem: reformaImg,
    tag: "Mudanças até 2033",
  },
  {
    slug: "mei-inss-aposentadoria",
    titulo: "MEI e INSS: como funciona a aposentadoria do microempreendedor",
    resumo:
      "Quanto o MEI contribui, benefícios e como complementar para se aposentar acima do mínimo.",
    categoria: "INSS",
    tempo: "10 min de leitura",
    imagem: inssImg,
    tag: "Aposentadoria do MEI",
  },
  {
    slug: "conta-pj-mei",
    titulo: "MEI precisa de conta bancária PJ? Regras e vantagens",
    resumo:
      "Não é obrigatório por lei, mas separar as finanças do negócio é uma das melhores decisões do MEI.",
    categoria: "Conta PJ",
    tempo: "9 min de leitura",
    imagem: contaPjImg,
    tag: "Conta bancária do MEI",
  },
  {
    slug: "mei-imposto-de-renda",
    titulo: "MEI precisa declarar Imposto de Renda? Entenda as regras",
    resumo:
      "DASN-SIMEI é uma coisa, IRPF é outra. Veja quando o MEI precisa fazer a declaração de PF.",
    categoria: "Imposto de Renda",
    tempo: "10 min de leitura",
    imagem: irpfImg,
    tag: "IRPF do MEI",
  },
  {
    slug: "beneficios-previdenciarios-mei",
    titulo: "Benefícios previdenciários do MEI: auxílio-doença, salário-maternidade e pensão",
    resumo: "Pagar o DAS dá acesso a uma rede de proteção que vai muito além da aposentadoria.",
    categoria: "Benefícios INSS",
    tempo: "10 min de leitura",
    imagem: beneficiosImg,
    tag: "Auxílios e pensões",
  },
  {
    slug: "certificado-digital-mei",
    titulo: "Certificado digital para MEI: quando é obrigatório e como obter",
    resumo: "e-CPF ou e-CNPJ? Veja em quais situações é exigido, qual escolher e quanto custa.",
    categoria: "Certificado Digital",
    tempo: "10 min de leitura",
    imagem: certDigImg,
    tag: "e-CNPJ e e-CPF",
  },
  {
    slug: "migrar-mei-para-me",
    titulo: "Como migrar do MEI para ME: quando e como fazer a transição",
    resumo:
      "Chegou no teto ou quer crescer? Veja a transição para Microempresa sem perder histórico.",
    categoria: "Migração",
    tempo: "10 min de leitura",
    imagem: migrarMeImg,
    tag: "MEI → ME",
  },
  {
    slug: "mei-e-commerce",
    titulo: "MEI e e-commerce: tudo que você precisa para vender online",
    resumo: "Marketplaces, loja própria, NF, limite de faturamento e dropshipping para o MEI.",
    categoria: "E-commerce",
    tempo: "10 min de leitura",
    imagem: ecommerceImg,
    tag: "Vendas online",
  },
  {
    slug: "mei-simples-nacional",
    titulo: "MEI e o Simples Nacional: como funciona a tributação do microempreendedor",
    resumo: "SIMEI, DAS fixo e isenções: por que é o regime tributário mais favorável do Brasil.",
    categoria: "Tributação",
    tempo: "10 min de leitura",
    imagem: simplesNacImg,
    tag: "SIMEI",
  },
  {
    slug: "mei-feminino",
    titulo: "MEI feminino: direitos, benefícios e proteções para a mulher empreendedora",
    resumo: "Salário-maternidade, auxílio-doença, aposentadoria e crédito para a mulher MEI.",
    categoria: "Mulher Empreendedora",
    tempo: "10 min de leitura",
    imagem: femininoImg,
    tag: "Direitos da mulher MEI",
  },
  {
    slug: "mei-inadimplente",
    titulo: "MEI inadimplente: o que acontece se você parar de pagar o DAS",
    resumo: "Multas, juros, perda de INSS, dívida ativa e como regularizar a situação.",
    categoria: "Inadimplência",
    tempo: "10 min de leitura",
    imagem: inadimplenteImg,
    tag: "DAS em atraso",
  },
  {
    slug: "mei-prestar-servico-pj",
    titulo: "MEI pode prestar serviço para empresa (PJ)? Saiba como funciona",
    resumo: "É legal sim. Veja como contratar com PJ e evitar a pejotização ilegal.",
    categoria: "Serviços para PJ",
    tempo: "10 min de leitura",
    imagem: servicoPjImg,
    tag: "Contratos com empresas",
  },
  {
    slug: "mei-clt-carteira-assinada",
    titulo: "MEI pode ter emprego com carteira assinada ao mesmo tempo?",
    resumo: "Dá para ser MEI e CLT. Veja regras, INSS e cuidados antes de abrir o CNPJ.",
    categoria: "MEI + CLT",
    tempo: "9 min de leitura",
    imagem: cltImg,
    tag: "Combinação MEI + CLT",
  },
  {
    slug: "mei-pode-ter-socio",
    titulo: "MEI pode ter sócio? Limitações e o que fazer",
    resumo: "MEI não aceita sócio. Veja as alternativas (SLU, LTDA) para empreender em parceria.",
    categoria: "Sociedade",
    tempo: "9 min de leitura",
    imagem: socioImg,
    tag: "Empresas com sócio",
  },
  {
    slug: "como-obter-cartao-cnpj-rapido",
    titulo: "Como obter o Cartão CNPJ rápido: guia passo a passo",
    resumo:
      "Emita o Cartão CNPJ em menos de 5 minutos pelo site da Receita Federal, de graça, e evite golpes nessa hora.",
    categoria: "Cartão CNPJ",
    tempo: "8 min de leitura",
    imagem: cnpjRapidoImg,
    tag: "Cartão CNPJ rápido",
  },
  {
    slug: "vantagens-cartao-cnpj-para-empresas",
    titulo: "Vantagens do Cartão CNPJ para empresas e MEIs",
    resumo:
      "Conta PJ, crédito, notas fiscais, credibilidade e proteção patrimonial: por que o Cartão CNPJ é estratégico.",
    categoria: "Cartão CNPJ",
    tempo: "9 min de leitura",
    imagem: cnpjVantagensImg,
    tag: "Vantagens do CNPJ",
  },
  {
    slug: "passo-a-passo-solicitar-cartao-cnpj",
    titulo: "Passo a passo para solicitar o Cartão CNPJ em PDF",
    resumo:
      "Guia atualizado para emitir e imprimir o Cartão CNPJ pela Receita Federal — no computador, celular ou app oficial.",
    categoria: "Cartão CNPJ",
    tempo: "8 min de leitura",
    imagem: cnpjPassoImg,
    tag: "Passo a passo",
  },
  {
    slug: "cartao-cnpj-documentacao-necessaria-dicas",
    titulo: "Cartão CNPJ: documentação necessária e dicas",
    resumo:
      "Documentos para abrir e atualizar o CNPJ, como manter o cadastro em dia e evitar problemas com a Receita Federal.",
    categoria: "Cartão CNPJ",
    tempo: "9 min de leitura",
    imagem: cnpjDocImg,
    tag: "Documentação do CNPJ",
  },
  {
    slug: "cartao-cnpj-importancia-legal",
    titulo: "Cartão CNPJ: entenda a sua importância legal",
    resumo:
      "Por que o Cartão CNPJ é tão exigido: situação cadastral, obrigações legais e proteção do empreendedor.",
    categoria: "Cartão CNPJ",
    tempo: "9 min de leitura",
    imagem: cnpjLegalImg,
    tag: "Importância legal",
  },
  {
    slug: "microempreendedor-individual-nota-fiscal-eletronica",
    titulo: "Microempreendedor Individual e Nota Fiscal Eletrônica: Guia Completo 2026",
    resumo: "NFS-e nacional, novo CRT 4 e obrigatoriedade por tipo de cliente para o MEI em 2026.",
    categoria: "Nota Fiscal",
    tempo: "9 min de leitura",
    imagem: nfeEletronicaImg,
    tag: "NFS-e e NF-e 2026",
  },
  {
    slug: "inss-mei-2026",
    titulo: "INSS MEI 2026: valores, benefícios e como pagar o DAS",
    resumo:
      "Tabela do DAS-MEI 2026, 6 benefícios previdenciários e como complementar para se aposentar com mais.",
    categoria: "INSS",
    tempo: "10 min de leitura",
    imagem: inss2026Img,
    tag: "INSS do MEI 2026",
  },
  {
    slug: "obrigacoes-mensais-mei",
    titulo: "Obrigações mensais do MEI: checklist completo 2026",
    resumo: "DAS, nota fiscal, faturamento, cadastro e DASN-SIMEI em um checklist mensal prático.",
    categoria: "Obrigações",
    tempo: "11 min de leitura",
    imagem: obrigMensaisImg,
    tag: "Checklist mensal",
  },
  {
    slug: "simulador-emprestimo-mei",
    titulo: "Simulador de Empréstimo MEI 2026: parcelas, juros e melhores taxas",
    resumo:
      "Como simular empréstimo MEI, comparar Pronampe, fintechs e bancos e entender CET e carência antes de assinar.",
    categoria: "Crédito MEI",
    tempo: "10 min de leitura",
    imagem: emprestimoMeiImg,
    tag: "Pronampe e crédito MEI",
  },
  {
    slug: "simulador-maquininha",
    titulo: "Melhor Maquininha para MEI em 2026: Compare Taxas Antes de Comprar",
    resumo:
      "Descubra qual é a melhor maquininha para MEI em 2026. Compare Stone, InfinitePay, Mercado Pago, Ton, PagBank e SumUp com taxas atualizadas e use nosso simulador gratuito.",
    categoria: "Maquininhas",
    tempo: "18 min de leitura",
    imagem: maquininhaImg,
    tag: "Melhor maquininha para MEI 2026",
  },
  {
    slug: "mei-vs-clt-2026",
    titulo: "MEI ou CLT em 2026: qual vale mais a pena? Compare com nosso simulador",
    resumo:
      "Isenção do IR até R$ 5.000, DAS-MEI 2026 e benefícios CLT lado a lado. Descubra qual regime entrega mais líquido para o seu perfil.",
    categoria: "MEI vs CLT",
    tempo: "8 min de leitura",
    imagem: meiVsCltImg,
    tag: "Comparativo MEI vs CLT 2026",
  },
  {
    slug: "ia-cnae-mei-2026",
    titulo: "CNAE MEI 2026: como a IA ajuda você a escolher a atividade certa",
    resumo:
      "Descreva sua atividade em linguagem natural e descubra com IA o CNAE certo do seu MEI — com DAS, vantagens e riscos.",
    categoria: "Formalização",
    tempo: "7 min de leitura",
    imagem: iaCnaeMeiImg,
    tag: "CNAE e formalização do MEI",
  },
  {
    slug: "dasn-simei-declaracao-anual",
    titulo: "Declaração Anual do MEI (DASN-SIMEI) 2026: passo a passo completo",
    resumo:
      "Prazo, passo a passo, multa de R$ 50, como declarar atrasado e como corrigir uma DASN-SIMEI já entregue.",
    categoria: "Obrigações Anuais",
    tempo: "11 min de leitura",
    imagem: dasnSimeiImg,
    tag: "Declaração anual do MEI",
  },
  {
    slug: "entregador-mercado-livre-mei",
    titulo:
      "Como abrir MEI para ser entregador do Mercado Livre: guia completo com CNAE certo e passo a passo",
    resumo:
      "CNAE correto (5320-2/02), como abrir o CNPJ no Portal do Empreendedor, cadastro na plataforma e quanto custa ser MEI entregador.",
    categoria: "Formalização",
    tempo: "10 min de leitura",
    imagem: entregadorMlImg,
    tag: "Entregador MEI",
  },
  // ── NOVOS ARTIGOS (blog) ───────────────────────────────────────────────────
  {
    slug: "marketing-digital-mei",
    titulo: "Marketing Digital para MEI 2026: Como Vender pelo Instagram, WhatsApp e Google",
    resumo:
      "Estratégias práticas de marketing digital para MEI: perfil comercial no Instagram, catálogo no WhatsApp Business e Google Meu Negócio.",
    categoria: "Marketing e Vendas",
    tempo: "19 min de leitura",
    imagem: marketingDigitalImg,
    tag: "Marketing Digital para MEI",
  },
  {
    slug: "nanoempreendedor-reforma-tributaria",
    titulo: "Nanoempreendedor e Reforma Tributária 2026: O que Muda para o MEI",
    resumo:
      "O MEI vai acabar? O que é o nanoempreendedor? Como o DAS muda com CBS e IBS? Nota fiscal obrigatória em 2027? Tudo explicado com base na legislação vigente.",
    categoria: "Legislação e Tributos",
    tempo: "18 min de leitura",
    imagem: nanoempreendedorImg,
    tag: "Reforma Tributária e MEI",
  },
] as const;

function ArtigosPage() {
  return (
    <>
      <section className="relative overflow-hidden border-b border-border">
        <div className="absolute inset-0 bg-gradient-hero opacity-95" />
        <div className="relative container mx-auto px-4 py-16 md:py-20 text-white">
          <div className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 backdrop-blur px-4 py-1.5 text-xs font-semibold uppercase tracking-wider">
            <BookOpen className="h-3.5 w-3.5" />
            Conteúdo para MEI
          </div>
          <h1 className="mt-5 font-display text-4xl md:text-5xl font-extrabold leading-tight max-w-3xl text-balance">
            Artigos práticos para o microempreendedor brasileiro
          </h1>
          <p className="mt-4 text-lg text-white/85 max-w-2xl">
            Guias diretos, sem juridiquês, sobre tudo o que envolve o seu MEI no dia a dia.
          </p>
        </div>
      </section>

      <section className="container mx-auto px-4 py-16 md:py-20">
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-2">
          {ARTIGOS_LIST.map((a, i) => (
            <article
              key={a.slug}
              className="group relative flex flex-col overflow-hidden rounded-2xl border border-border bg-card shadow-soft hover:shadow-elevated transition-all"
            >
              <div className="relative aspect-[16/9] overflow-hidden bg-muted">
                <img
                  src={a.imagem}
                  alt={`${a.titulo} — guia MEI`}
                  title={a.titulo}
                  width={1280}
                  height={720}
                  loading={i < 2 ? "eager" : "lazy"}
                  fetchPriority={i === 0 ? "high" : i < 2 ? "auto" : "low"}
                  decoding="async"
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />

                <span className="absolute top-3 left-3 inline-flex items-center rounded-full bg-background/90 backdrop-blur px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-primary">
                  {a.tag}
                </span>
              </div>
              <div className="p-6 flex flex-col flex-1">
                <div className="text-xs font-bold uppercase tracking-widest text-primary mb-2">
                  {a.categoria}
                </div>
                <h2 className="font-display text-xl font-bold leading-snug group-hover:text-primary transition">
                  <Link
                    to="/artigos/$slug"
                    params={{ slug: a.slug }}
                    className="hover:underline after:absolute after:inset-0 after:z-10"
                  >
                    {a.titulo}
                  </Link>
                </h2>
                <p className="mt-3 text-sm text-muted-foreground leading-relaxed flex-1">
                  {a.resumo}
                </p>
                <div className="mt-5 flex items-center justify-between text-xs text-muted-foreground">
                  <span>{a.tempo}</span>
                  <span className="inline-flex items-center gap-1 font-semibold text-primary">
                    Ler artigo <ArrowRight className="h-3.5 w-3.5" />
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="container mx-auto px-4 py-16 border-t border-border">
        <div className="prose prose-lg max-w-3xl mx-auto dark:prose-invert">
          <h2 className="font-display text-3xl font-bold">
            Conteúdo prático para o microempreendedor individual
          </h2>
          <p>
            Aqui no <strong>blog do MEI Toolbox</strong> a gente reúne{" "}
            <strong>guias atualizados sobre tudo o que envolve ser MEI no Brasil</strong>: desde a
            formalização do CNPJ até o desenquadramento, passando por{" "}
            <strong>
              DAS, nota fiscal eletrônica, INSS, Simples Nacional, limite de faturamento, obrigações
              mensais
            </strong>{" "}
            e direitos previdenciários. São conteúdos pensados para quem não tem contador no dia a
            dia e precisa entender o assunto com clareza, sem juridiquês, e sair do artigo já
            sabendo o que fazer.
          </p>

          <h2 className="font-display text-3xl font-bold">O que você encontra no blog</h2>

          <h3 className="font-semibold text-xl">Fundamentos do MEI</h3>
          <p>
            O que é MEI, quem pode se formalizar, lista de atividades permitidas, diferença entre
            MEI e ME, regras do Simples Nacional e do SIMEI. Material essencial para quem está
            começando.
          </p>

          <h3 className="font-semibold text-xl">DAS, INSS e tributação</h3>
          <p>
            Como gerar e pagar o DAS pelo PGMEI e pelo app MEI, valores atualizados de 2026, multa e
            juros por atraso, parcelamento de dívidas, contribuição complementar para aposentar com
            mais e cálculo do imposto de renda do MEI.
          </p>

          <h3 className="font-semibold text-xl">Nota fiscal e obrigações mensais</h3>
          <p>
            Quando o MEI é obrigado a emitir nota, como funciona a <strong>NFS-e nacional</strong> e
            o novo <strong>CRT 4</strong>, diferenças entre NF-e, NFS-e e NFC-e, checklist mensal e
            como entregar a DASN-SIMEI sem erro.
          </p>

          <h3 className="font-semibold text-xl">Faturamento, crescimento e migração</h3>
          <p>
            Como acompanhar o <strong>limite de faturamento</strong> dos R$ 81.000, o que acontece
            se passar do teto, como migrar do MEI para ME, abrir conta PJ e organizar a{" "}
            <strong>gestão financeira do MEI</strong>.
          </p>

          <h3 className="font-semibold text-xl">Direitos, benefícios e situações específicas</h3>
          <p>
            Auxílio-doença, salário-maternidade, aposentadoria, MEI mulher, MEI com CLT, MEI com
            nome sujo, MEI em e-commerce, prestar serviço para PJ sem cair em pejotização e muito
            mais.
          </p>

          <h2 className="font-display text-3xl font-bold">Por que confiar no MEI Toolbox</h2>
          <ul>
            <li>
              <strong>Conteúdo atualizado</strong> com as regras de 2026: tabela do DAS, INSS, CRT 4
              da NFS-e e Reforma Tributária.
            </li>
            <li>
              <strong>Linguagem direta</strong>, escrita para o microempreendedor brasileiro — não
              para advogado.
            </li>
            <li>
              <strong>Ferramentas integradas</strong>: cada artigo aponta para a calculadora ou
              gerador que resolve a situação na prática.
            </li>
            <li>
              <strong>100% gratuito</strong>, sem cadastro e com privacidade real.
            </li>
          </ul>

          <h2 className="font-display text-3xl font-bold">Combine artigo + ferramenta</h2>
          <p>Toda dúvida sobre MEI vira ação aqui no MEI Toolbox. Algumas combinações úteis:</p>
          <ul>
            <li>
              Leu sobre DAS? Calcule o seu na{" "}
              <Link to="/ferramentas/$slug" params={{ slug: "calculadora-das-mei" }}>
                Calculadora DAS MEI
              </Link>
              .
            </li>
            <li>
              Entendeu o limite de faturamento? Simule em{" "}
              <Link to="/ferramentas/$slug" params={{ slug: "limite-faturamento-mei" }}>
                Calculadora de Limite MEI
              </Link>
              .
            </li>
            <li>
              Vai emitir recibo para cliente? Use o{" "}
              <Link to="/ferramentas/$slug" params={{ slug: "gerador-recibo" }}>
                Gerador de Recibo
              </Link>
              .
            </li>
            <li>
              Precisa validar um CNPJ antes de fechar negócio? Abra o{" "}
              <Link to="/ferramentas/$slug" params={{ slug: "validador-cnpj" }}>
                Validador de CNPJ
              </Link>
              .
            </li>
          </ul>

          <h2 className="font-display text-3xl font-bold">Perguntas frequentes sobre MEI</h2>

          <h3 className="font-semibold text-xl">Quais são as obrigações mensais do MEI em 2026?</h3>
          <p>
            Todo mês o MEI precisa pagar o DAS (boleto único com INSS, ISS e ICMS), emitir nota
            fiscal nas vendas para empresas (PJ), controlar o faturamento para não passar do teto
            anual de R$ 81.000 e guardar os comprovantes por pelo menos 5 anos.
          </p>

          <h3 className="font-semibold text-xl">Qual o valor do DAS MEI em 2026?</h3>
          <p>
            Em 2026 o DAS-MEI tem como base R$ 81,05 de INSS (5% do salário mínimo), mais R$ 1 de
            ICMS para comércio/indústria e R$ 5 de ISS para serviços. O valor final depende da sua
            atividade.
          </p>

          <h3 className="font-semibold text-xl">
            Como funciona a nota fiscal eletrônica para MEI?
          </h3>
          <p>
            Desde 2026 o MEI usa o padrão nacional da NFS-e (serviços) e o novo CRT 4. A emissão é
            obrigatória nas vendas para empresas e opcional para pessoa física. Pode ser feita pelo
            portal nacional ou pela prefeitura.
          </p>

          <h3 className="font-semibold text-xl">Qual o limite de faturamento do MEI?</h3>
          <p>
            O teto atual do MEI é R$ 81.000 por ano. Ultrapassar até 20% (R$ 97.200) leva ao
            desenquadramento no ano seguinte. Acima disso, o desenquadramento é retroativo.
          </p>

          <h3 className="font-semibold text-xl">MEI precisa declarar Imposto de Renda?</h3>
          <p>
            São duas obrigações diferentes. A DASN-SIMEI é anual e obrigatória para todo MEI. Já a
            declaração de IRPF (pessoa física) só é exigida se o titular se enquadrar nas regras
            gerais da Receita Federal.
          </p>
        </div>
      </section>
    </>
  );
}
